import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'
import axios from 'axios'
import qs from 'qs'

import { ClientBehaviours } from '../../../utils'
import { RecentPostsArgs } from '../../../../../types/enterpriseTypes'

export const RecentPosts = (
  _client: ApolloClient<NormalizedCacheObject>,
  {
    behaviours,
  }: {
    behaviours: ClientBehaviours
  },
) => async (_, args: RecentPostsArgs) => {
  if (behaviours.override) {
    const { asgardPostsMock } = await import('./AsgardPosts.mock')
    const mockPostData = asgardPostsMock.data
      .slice(args.offset, args.offset + args.limit)
      .map((mockPost) => {
        delete mockPost.imageSource
        return { ...mockPost, __typename: 'RecentPost' }
      })
    return mockPostData
  }

  const requestData = qs.stringify(
    {
      link: args.slug,
      token: args.token,
      offset: args.offset,
      size: args.limit,
      exclude: args.exclude,
    },
    { arrayFormat: 'brackets' },
  )
  const { data } = await axios.post(
    'https://asgard.thehut.net/infinite',
    requestData,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  )

  const postData = data?.data?.map((post) => {
    return { ...post, __typename: 'RecentPost' }
  })

  return postData
}
